import { SingleLineTextHelper } from './SingleLineText';
export class UrlHelper extends SingleLineTextHelper {
    constructor() {
        super(...arguments);
        this.columnDefaultMeta = {};
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9jb2x1bW5IZWxwZXIvY29sdW1ucy9VcmwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLG9CQUFvQixFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFFeEQsTUFBTSxPQUFPLFNBQVUsU0FBUSxvQkFBb0I7SUFBbkQ7O1FBQ0Usc0JBQWlCLEdBQUcsRUFBRSxDQUFDO0lBQ3pCLENBQUM7Q0FBQSJ9